import { useMemo } from "react";
import useCurrentFacility from "app/utils/hooks/scheduling/useCurrentFacility";

/**
 * Can this program take an online payment right now?
 *
 * CN-2868: this used to read the Stripe status of `coaches[0]` whenever the
 * program named no collecting coach. A program collected by the **facility**
 * names none, so a facility with Stripe connected looked disconnected if its
 * coach had no Stripe of his own, and the registration form fell back to
 * offline on a program that only accepts online payments.
 *
 * The collector is a coach only when the program names one of its own coaches.
 * Anything else means the facility collects, so the facility's integration is
 * the one that counts. The `coaches[0]` reading is kept as a last resort for
 * older programs that recorded no collector at all.
 */
const useProgramStripeIntegration = (programModel: any): boolean => {
  const { data: facility } = useCurrentFacility();

  return useMemo(() => {
    if (!programModel) {
      return false;
    }

    const coaches = programModel.coaches ?? [];
    const collectorCoach = coaches.find(
      (coach: any) => coach.id === programModel.paymentCollectorCoachProfileId,
    );

    if (collectorCoach) {
      return Boolean(collectorCoach.stripeIntegrationEnabled);
    }

    return (
      Boolean(facility?.stripeIntegrationEnabled) ||
      Boolean(coaches[0]?.stripeIntegrationEnabled)
    );
  }, [programModel, facility?.stripeIntegrationEnabled]);
};

export default useProgramStripeIntegration;
